import React, { useState } from 'react';
import '../../styles/components/image-selector.css';

interface ImageItem {
  id: string;
  src: string;
  thumbnail: string;
  label: string;
  alt?: string;
}

interface ImageSelectorProps {
  images: ImageItem[];
  className?: string;
}

const ImageSelector: React.FC<ImageSelectorProps> = ({ images, className = '' }) => {
  const [selectedId, setSelectedId] = useState<string>(images[0]?.id || '');

  const selectedImage = images.find(img => img.id === selectedId) || images[0];

  if (!images || images.length === 0) {
    return <div className="image-selector-empty">No images provided</div>;
  }

  return (
    <div className={`image-selector ${className}`}>
      {/* Main Image Display */}
      <div className="image-selector-main">
        <img 
          src={selectedImage.src} 
          alt={selectedImage.alt || selectedImage.label}
          className="image-selector-main-image"
        />
      </div>

      {/* Thumbnail Selectors */}
      <div className="image-selector-thumbnails">
        {images.map((image) => (
          <div
            key={image.id}
            className={`image-selector-thumbnail ${selectedId === image.id ? 'selected' : ''}`}
            onClick={() => setSelectedId(image.id)}
          >
            <div className="image-selector-circle">
              <img 
                src={image.thumbnail} 
                alt={image.alt || image.label}
                className="image-selector-circle-image"
              />
            </div>
            <span className="image-selector-label">
              {image.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageSelector; 